<template>
  <div class="about">
    <h1>This is the shop page</h1>
  </div>
</template>